var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeroSection'),_c('CategoryFilter'),_c('BrandFilter'),_c('main',{staticClass:"main-content"},[_c('ProductGrid')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }